import { Vec2d } from '@tldraw/tldraw'
import { getCurrentFrame, pageToViewport } from 'components/VisualStudioPlayground/VisualEditor/helpers'
import { useEditor } from 'components/VisualStudioPlayground/VisualEditorContext'
import { OFFSET, TOOLBAR_HEIGHT } from './constants'

export const useToolbarPlacement = () => {
  const editor = useEditor()
  const selectionRotatedPageBounds = editor.getSelectionRotatedPageBounds()
  if (!selectionRotatedPageBounds) return 'top'

  const topCenter = new Vec2d(selectionRotatedPageBounds.center.x, selectionRotatedPageBounds.y)
  const bottomCenter = new Vec2d(selectionRotatedPageBounds.center.x, selectionRotatedPageBounds.maxY)

  const viewportTopCenter = pageToViewport(editor, topCenter)

  const placement =
    viewportTopCenter.y < TOOLBAR_HEIGHT + OFFSET && bottomCenter.y <= getCurrentFrame(editor).props.h
      ? 'bottom'
      : 'top'

  return placement
}
